goog.module('yext.dam.assetselector.types');
goog.module.declareLegacyNamespace();

const types = {
  TEXT: 'TEXT',
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
  CUSTOM: 'CUSTOM',
};

exports = types;
